module.exports = __webpack_public_path__ + "images/style-2-d1513bd993460d04c3b0a9e490f4c908.jpg";